/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiScenarioCategory
 */
export interface InternalApiScenarioCategory {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioCategory
     */
    id: string;
    /**
     * Scenario category name
     * @type {string}
     * @memberof InternalApiScenarioCategory
     */
    name: string;
    /**
     * Scenario category abbreviation
     * @type {string}
     * @memberof InternalApiScenarioCategory
     */
    abbreviation: string;
}

/**
 * Check if a given object implements the InternalApiScenarioCategory interface.
 */
export function instanceOfInternalApiScenarioCategory(value: object): value is InternalApiScenarioCategory {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('abbreviation' in value) || value['abbreviation'] === undefined) return false;
    return true;
}

export function InternalApiScenarioCategoryFromJSON(json: any): InternalApiScenarioCategory {
    return InternalApiScenarioCategoryFromJSONTyped(json, false);
}

export function InternalApiScenarioCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioCategory {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'abbreviation': json['abbreviation'],
    };
}

export function InternalApiScenarioCategoryToJSON(json: any): InternalApiScenarioCategory {
    return InternalApiScenarioCategoryToJSONTyped(json, false);
}

export function InternalApiScenarioCategoryToJSONTyped(value?: InternalApiScenarioCategory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'abbreviation': value['abbreviation'],
    };
}

